var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-skeleton-loader',{attrs:{"width":737,"height":40}},[_c('rect',{attrs:{"width":"20","height":"20","y":"12","x":"8","rx":4}}),_vm._v(" "),_c('rect',{attrs:{"width":"30%","height":"12","y":"16","x":"40","rx":4}})])
}
var staticRenderFns = []

export { render, staticRenderFns }